import React from "react";

export default function Footer() {
  return (
    <footer>
      The project is made by{" "}
      <a href="https://www.linkedin.com/in/kateryna-tsygankova-15a429244/">
        Kateryna Tsygankova
      </a>
      , open-sourced on{" "}
      <a href="https://github.com/tsyganek/react-project-weather">GitHub</a> and
      hosted on{" "}
      <a href="https://fastidious-khapse-d7e976.netlify.app">Netlify</a>
    </footer>
  );
}
